import React from 'react';

const Placeholder = () => {
  return (
    <p aria-hidden="true" className="placeholder-glow">
      <span className="w-100 placeholder placeholder-lg col-12"></span>
    </p>
  );
};

export default Placeholder;